<template>
  <div
    :class="[
      'player_pane',
      playConfig.status,
      window.innerWidth > window.innerHeight && playConfig.status === 'mini'
        ? 'mini_landscape'
        : '',
    ]"
    @click="ckPlayerPane()"
  >
    <div
      :class="{
        player_box: true,
        player_box_landscape:
          window.innerWidth > window.innerHeight &&
          playConfig.status === 'full',
      }"
      :style="{
        height:
          window.innerWidth > window.innerHeight
            ? window.innerHeight * (playConfig.status === 'mini' ? 0.4 : 1) +
              'px'
            : (videoHeight / videoWidth) *
              window.innerWidth *
              (playConfig.status === 'mini' ? 0.4 : 1) +
              'px',
      }"
    >
      <!-- :poster="mediaData.bgImg" -->
      <video
        ref="video"
        :class="{
          media_video: true,
          full_landscape:
            window.innerWidth > window.innerHeight &&
            playConfig.status === 'full',
        }"
        preload="metadata"
        :src="mediaData.videoUrl"
        webkit-playsinline="true"
        playsinline="true"
        x5-video-player-type="h5-page"
      />

      <VideoPop
        v-if="
          isShowVideoPop &&
            mediaData.productInfo &&
            playConfig.status !== 'mini'
        "
        :product-info="mediaData.productInfo"
        :theme="theme"
      />

      <div
        v-if="isShowVideoTitle && playConfig.status !== 'mini'"
        :class="['media_video_title', theme]"
      >
        {{
          mediaData.productInfo && mediaData.productInfo.firstName
            ? mediaData.productInfo.name
            : '您'
        }}的专属保障方案
      </div>
    </div>

    <div v-if="playConfig.status === 'full'" class="player_right_btn">
      <p class="player_right_btn_close" @click.stop="ckCloseIcon">
        <i class="iconfont icon-close_line" />
      </p>
      <p class="player_right_btn_muted" @click="switchMuted">
        <i
          class="iconfont"
          :class="isMuted ? 'icon-voiceclose' : 'icon-voiceopen'"
        />
      </p>
    </div>
    <VideoControls
      v-if="isShowPlayerControls && playConfig.status === 'full'"
      v-model="precent"
      :playing="playing"
      :current-time-stamp="currentTimeStamp"
      :duration-time-stamp="durationTimeStamp"
      :theme="theme"
      @showPlayerControls="showPlayerControls"
      @switchPlay="switchPlay"
      @input="seek"
      @change="seek"
      @movestart="touchstart"
      @moveend="touchend"
    />
    <div
      v-if="playConfig.status === 'mini'"
      class="mini_close_icon"
      @click.stop="closeVideoPlayer"
    >
      <i class="iconfont icon-close_line" />
    </div>
    <!-- <div v-if="video" :key="video.currentTime" style="text-align: center; position: fixed; top: 0; color: #f00; font-size: 14px; text-align: center;">
      <p v-if="video" style="white-space: nowrap;">
        视频：{{video.paused}} {{video.currentTime}} 音频：{{currentAudioTime}} <br/>
        时差：{{video.currentTime - currentAudioTime }}
      </p>
      <p>
        {{isVideoCanplay}} {{isWebAudioCanplay}} 同步：{{debuggerMsg}} {{isAlreadyPlayed}} 系统版本：{{androidVersion}}
      </p>
    </div> -->
  </div>
</template>

<script>
import { Howl } from 'howler'
import {
  parseTime,
  orientationChanged,
  getAndroidVersion
} from './components/utils'
import * as CM from 'common/js/common'
import VideoControls from './components/videoControls.vue'
import VideoPop from './components/videoPop.vue'
import { Loading } from 'bxs-ui-vue'
import Jax from '@bxs/jax'

export default {
  name: 'MyVideo21',
  components: {
    [Loading.name]: Loading,
    VideoControls,
    VideoPop
  },
  props: {
    theme: String,
    playConfig: {
      type: Object,
      default () {
        return {}
      }
    },
    productVideo: {
      type: Object,
      default () {
        return {}
      }
    },
    mediaData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      androidVersion: getAndroidVersion(),
      isShowPlayerControls: true,
      isShowVideoTitle: false,
      isShowVideoPop: false,
      isAlreadyPlayed: false,

      // video相关参数
      video: null,
      isVideoCanplay: false,
      currentVideoTime: 0,
      videoHeight: 1080,
      videoWidth: 1920,
      isTouchMove: false,
      duration: 0,
      precent: 0,
      playing: false,
      isMuted: false,

      // Web audio API
      sound: null,
      isWebAudioCanplay: false,
      currentAudioTime: 0, // 当前音频播放时间点
      audioSeekTime: 0, // seek查询的时间点
      audioStartTime: 0, // 开始播放的时间点

      // 定时器
      controlsTimer: null, // 3s后，隐藏控件界面
      videoAndAudioTimer: null, // 每500ms，判断音、视频是否可播放
      audioSyncTimer: null, // 每500ms，判断音、视频是否同步

      window,

      // 测试用
      debuggerMsg: 0
    }
  },
  computed: {
    durationTimeStamp () {
      return this.formatTime(this.duration)
    },
    currentTimeStamp () {
      return this.formatTime(this.currentVideoTime)
    }
  },
  watch: {
    'playConfig.status' (val) {
      switch (val) {
        case 'full':
          if (document.body.style.position !== 'fixed') {
            CM.stopBodyScroll(true)
          }
          break
        default:
          break
      }
    }
  },
  mounted () {
    let self = this
    self.video = self.$refs.video

    // 监听屏幕旋转
    window.addEventListener(
      'orientationchange',
      () => {
        orientationChanged().then(() => {
          setTimeout(() => {
            self.$forceUpdate()
          }, 300)
        })
      },
      false
    )

    // 切换应用时，暂停播放；重回应用，刷新页面
    document.addEventListener('visibilitychange', e => {
      if (e.target.hidden || document.visibilityState === 'hidden') {
        self.switchPlay(false)
      }
    })
    this.bindVideoListeners()
  },
  methods: {
    ckPlayerPane () {
      switch (this.playConfig.status) {
        case 'full':
          this.showPlayerControls()
          return false
          break
        default:
          break
      }
    },
    ckCloseIcon () {
      if (this.playConfig.status === 'full') {
        CM.stopBodyScroll(false)
      }
      if (this.playing) {
        this.playConfig.status = 'normal'
        this.$nextTick(() => {
          this.switchPlay(true)
        })
      } else {
        this.closeVideoPlayer()
      }
    },
    // 关闭播放浮层
    closeVideoPlayer () {
      clearInterval(this.videoAndAudioTimer)
      clearInterval(this.audioSyncTimer)
      this.switchPlay(false)
      this.playConfig.status = ''
      this.playConfig.playingVideoId = null
      this.$emit('wxClientSaveOperate')
      window.WeiyiStatSDK.submit(
        Jax.isApp() ? 'sp_a_exit' : 'sp_c_exit',
        this.getVideoMetadata()
      )
    },
    // 本地缓存埋点数据
    getVideoMetadata () {
      let { video } = this
      let vMetadata = {
        videoProductId: this.productVideo.productId,
        total_length: this.duration,
        watch_length: 0,
        v: this.productVideo.version + '.0',
        spbb: this.mediaData.key,
        id: this.mediaData.id,
        playing: this.playing
      }
      if (video.played && video.played.length) {
        for (let k = 0; k < video.played.length; k++) {
          vMetadata.watch_length += video.played.end(k) - video.played.start(k)
        }
      }
      localStorage.setItem('PlayingVideoMetadata', JSON.stringify(vMetadata))
      return vMetadata
    },
    // 显示播放器控件
    showPlayerControls () {
      let self = this
      self.isShowPlayerControls = true
      self.controlsTimer && clearTimeout(self.controlsTimer)
      self.controlsTimer = setTimeout(() => {
        self.isShowPlayerControls = false
      }, 3000)
    },
    // 视频绑定事件
    bindVideoListeners () {
      let self = this
      // 视频元数据是否加载完成。有兼容关题，IOS(测试机 iphone 6p)取不到时长、宽高等数据
      self.video.addEventListener('loadedmetadata', () => {
        self.duration = self.video.duration
        self.videoWidth = self.video.videoWidth
        self.videoHeight = self.video.videoHeight
      })

      // 监听视频currentTime值的变化
      self.video.addEventListener('timeupdate', () => {
        if (!self.isTouchMove) {
          self.currentPrecent(self.video.currentTime)
        }
        if (!this.duration) {
          this.duration = self.video.duration
        }
        if (!this.videoWidth) {
          this.videoWidth = self.video.videoWidth
        }
        if (!this.videoHeight) {
          this.videoHeight = self.video.videoHeight
        }
        self.currentVideoTime = self.video.currentTime

        // 是否显示产品信息浮层、标题
        if (self.mediaData.productInfo) {
          self.isShowVideoPop =
            self.currentVideoTime >= self.mediaData.productInfo.startTime &&
            self.currentVideoTime <= self.mediaData.productInfo.endTime
        }
        self.isShowVideoTitle =
          !self.isShowVideoPop &&
          self.currentVideoTime >= 5 &&
          self.currentVideoTime < self.duration - 6

        // 缓存视频元数据
        self.getVideoMetadata()
      })

      self.video.addEventListener('canplay', () => {
        self.isVideoCanplay = true
      })

      self.video.addEventListener('seeked', () => {
        self.isVideoCanplay = true
      })

      self.video.addEventListener('pause', () => {
        self.playOrPauseWebAudio(false)
      })

      self.video.addEventListener('ended', () => {
        self.playing = false
      })
    },
    // 用于用户第一次手动触发播放
    startPlay () {
      this.isAlreadyPlayed = true
      this.playing = true
      if (this.video) {
        this.video.play()
      }
      if (this.mediaData.audioUrl) {
        this.playWebAudio(this.mediaData.audioUrl)
        this.syncPlayVideoAndAudio()
      }
    },
    // 音频、视频都可以播放时，两者同步播放
    syncPlayVideoAndAudio () {
      let self = this
      clearInterval(self.videoAndAudioTimer)
      self.videoAndAudioTimer = setInterval(() => {
        if (self.video && self.sound) {
          if (self.isVideoCanplay && self.isWebAudioCanplay) {
            self.switchPlay(true)
            clearInterval(self.videoAndAudioTimer)
          } else {
            self.switchPlay(false)
          }
        }
      }, 500)
    },
    // 创建web audio
    async playWebAudio (url) {
      let self = this
      self.sound = new Howl({
        src: [url],
        onload (id) {
          self.sound.seek(self.video.currentTime)
          self.audioSeekTime = self.video.currentTime
          self.playOrPauseWebAudio(true)
        },
        onseek () {
          if (!self.isWebAudioCanplay) {
            self.isWebAudioCanplay = true
          }
        }
      })
    },
    // 切换播放状态。
    // bool: Boolean。true: 播放；false: 暂停；不传(undefined), 切换
    switchPlay (bool) {
      this.playing = bool === undefined ? !this.playing : bool
      if (this.playing) {
        if (this.video) {
          this.video.play()
        }
        this.playOrPauseWebAudio(true)
      } else {
        if (this.video) {
          this.playPromise = this.video.play()
          if (this.playPromise !== undefined) {
            this.playPromise
              .then(() => {
                this.video.pause()
              })
              .catch(() => {
                this.video.pause()
              })
          }
        }
        this.playOrPauseWebAudio(false)
      }
      this.showPlayerControls()
    },
    // 播放或暂停音频。true: 播放；false: 暂停
    playOrPauseWebAudio (bool) {
      if (this.sound) {
        if (bool) {
          this.sound.pause()
          this.sound.play()
          this.audioStartTime = new Date().getTime() / 1000
          this.setAudioFollowVideo()
        } else {
          this.sound.pause()
        }
      }
    },
    // 音频进度，跟随视频
    setAudioFollowVideo () {
      let self = this
      clearInterval(this.audioSyncTimer)
      self.audioSyncTimer = setInterval(() => {
        if (
          self.video &&
          self.sound &&
          self.playing &&
          self.isVideoCanplay &&
          self.isWebAudioCanplay
        ) {
          if (self.video.paused) {
            self.playOrPauseWebAudio(false)
          } else {
            // 实时音频进度
            self.currentAudioTime =
              self.audioSeekTime +
              new Date().getTime() / 1000 -
              self.audioStartTime
            if (
              Math.abs(self.video.currentTime - self.currentAudioTime) > 0.5
            ) {
              self.sound.seek(self.video.currentTime)
              self.audioSeekTime = self.video.currentTime
              self.playOrPauseWebAudio(true)
              self.debuggerMsg++
            }
          }
        }
      }, 500)
    },
    switchMuted () {
      this.isMuted = !this.isMuted
      if (this.video && !this.mediaData.audioUrl) {
        this.video.muted = this.isMuted
      }
      if (this.sound) {
        this.sound.mute(this.isMuted)
      }
    },
    seek (precent) {
      const t = Math.abs((this.duration * precent) / 100)
      if (this.video) {
        this.video.currentTime = t
      }
      if (this.sound) {
        this.sound.seek(t)
        this.audioSeekTime = t
      }
      if (this.mediaData.audioUrl) {
        this.isVideoCanplay = false
        this.isWebAudioCanplay = false
        this.playing = true
        this.syncPlayVideoAndAudio()
      } else {
        this.switchPlay(true)
      }
    },
    touchstart () {
      this.isTouchMove = true
    },
    touchend () {
      this.isTouchMove = false
    },
    formatTime (time) {
      const t = new Date(parseInt(time * 1000, 10))
      const formatter = time >= 60 * 60 ? '{h}:{i}:{s}' : '{i}:{s}'
      return parseTime(t, formatter)
    },
    currentPrecent (currentTime) {
      const diff = Math.floor((currentTime / this.duration) * 10000) / 100
      this.precent = diff
    }
  }
}
</script>

<style>
html {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.player_pane {
  .player_box {
    width: 100%;
    font-size: 0;
    &.player_box_landscape {
      position: absolute;
      left: 0;
      top: 0;
      transform: translateY(0);
    }
    & .media_video {
      display: block;
      width: 100%;
      height: auto;
      margin: 0 auto;
      vertical-align: top;
      &.full_landscape {
        width: auto;
        height: 100%;
      }
    }
    & .media_audio {
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 1px;
      opacity: 0;
      pointer-events: none;
      z-index: 1;
    }
    & .media_video_title {
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
      display: block;
      margin: 0 auto;
      padding: 10px 4px;
      width: 0.32rem;
      max-height: 80%;
      line-height: 1.2;
      font-size: 12px;
      color: #fff;
      z-index: 3;
      background-color: rgba(125, 113, 250, 0.75);
      border-radius: 2rem;
      box-sizing: content-box;
      text-align: center;
      overflow: hidden;
      &.diff {
        background-color: rgba(217, 73, 38, 0.75);
      }
    }
    & .player_btn_start {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 101%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 4;
      span {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 42px;
        height: 42px;
        border: 3px solid #fff;
        border-radius: 50px;
        color: #fff;
        > i {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 24px;
          &.icon-weibiaoti-5-01 {
            left: 55%;
          }
        }
      }
    }
    & .media_video_poster {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      margin: 0 auto;
      width: 100%;
      height: 100%;
      z-index: 3;
    }
  }
  & .player_right_btn {
    position: absolute;
    top: 20px;
    right: 16px;
    width: 30px;
    z-index: 1;
    color: #fff;
    & .player_right_btn_close,
    & .player_right_btn_muted {
      position: relative;
      width: 30px;
      height: 30px;
      margin-bottom: 12px;
      border-radius: 30px;
      background: rgba(255, 255, 255, 0.1);
      > i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 22px;
      }
    }
  }
  & .mini_close_icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    & .icon-close_line {
      font-size: 18px;
      color: #fff;
    }
  }
}
.player_pane.full {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 1);
  overflow: auto;
  z-index: 10;
  .player_box {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
  }
}
.player_pane.normal {
}
.player_pane.mini {
  position: fixed;
  bottom: 100px;
  right: 10px;
  width: 40%;
  z-index: 10;
}
.mini_landscape.mini {
  bottom: 60px;
}
</style>
